import { FormProvider, useForm } from 'react-hook-form';
import { useLocation, matchPath } from 'react-router-dom';
import { Box } from '@material-ui/core';
import { MDSPanel, MDSPanelBody, MDSPanelHeader, MDSToastSnackbar } from '@marqvision/mds/core';
import { UrlPathsWithAllLanguages } from '~/hooks/useRouteNames';
import { ISignInUp } from '~/models';
import useBreakpoint from '../../hooks/useBreakpoint';
import useLanguage from '../../hooks/useLanguage';
import SignInUp from '../SignInUp';

interface IProps {
  open: boolean;
  onClose: (isLoggedIn?: boolean) => void;
}

const AccountPanel = ({ open, onClose }: IProps): JSX.Element => {
  const methods = useForm<ISignInUp>({ mode: 'all', reValidateMode: 'onChange' });
  const { pathname } = useLocation();
  const { Lang } = useLanguage();

  const isMatchFileAnApplication = UrlPathsWithAllLanguages.FileAnApplication.map((route) =>
    matchPath(route, pathname)
  ).some((item) => Boolean(item));

  const { getMediaQueryValue: mq } = useBreakpoint();

  return (
    <MDSPanel
      open={open}
      onClose={() => onClose()}
      anchor="right"
      width={mq('360px', '492px', '492px')}
      BackdropProps={{ invisible: true }}
    >
      <MDSPanelHeader title={Lang.Login} onClose={() => onClose()} style={{ boxSizing: 'border-box' }} />
      <MDSPanelBody style={{ width: mq('360px', '492px', '492px'), boxSizing: 'border-box' }}>
        <Box padding={mq('24px 40px', null, '40px 60px')}>
          <FormProvider {...methods}>
            <SignInUp
              variant="dense"
              onSignIn={() => {
                onClose(true);
                MDSToastSnackbar({
                  type: 'succeed',
                  title: isMatchFileAnApplication ? Lang.LoginSuccessAndAutoSaved : Lang.LoginSuccessful,
                });
              }}
              onSignUp={() => {
                onClose(true);
                MDSToastSnackbar({
                  type: 'succeed',
                  title: isMatchFileAnApplication ? Lang.LoginSuccessAndAutoSaved : Lang.LoginSuccessful,
                });
              }}
            />
          </FormProvider>
        </Box>
      </MDSPanelBody>
    </MDSPanel>
  );
};

export default AccountPanel;
